<template>
    <div class="w-swiper" :style="{height: height + 'px'}">
        <Swipe :show-indicators="false" :touchable="true" indicator-color="white" @change="swipeChange">
            <SwipeItem v-if="type == 'lifestyle' && video">
                <video
                    ref="video"
                    :poster="cover"
                    class="swiper-video"
                    :src="video"
                    muted
                    loop
                    x5-video-player-type="h5"
                >
                </video>
                <div class="video-control" v-show="!isPlay">
                    <i class="iconfont icon-Play" @click="playVideo"></i>
                </div>
            </SwipeItem>
            <SwipeItem v-if="(type == 'house' || type == 'home') && video">
                <video
                    ref="video"
                    :poster="util.videoPoster(video)"
                    class="swiper-video"
                    :src="video"
                    muted
                    loop
                    x5-video-player-type="h5"
                ></video>
                <div class="video-control" v-show="type == 'house' && !isPlay">
                    <i class="iconfont icon-Play" @click="playVideo"></i>
                </div>
            </SwipeItem>
            <SwipeItem v-for="item in imgs" :key="item">
                <img class="swiper-image" :src="util.thumb(item, 1125)" />
            </SwipeItem>
        </Swipe>
        <div class="dots" v-if="dotCount > 1">
            <div
                class="dot"
                v-for="(item, index) in dotCount"
                :key="item"
                :class="{'dot-active': index == swiperIndex}"
            ></div>
        </div>
    </div>
</template>

<script>
import { Swipe, SwipeItem } from "vant";

export default {
    components: {
        Swipe,
        SwipeItem
    },
    props: {
        // 类型 lifestyle house user home
        type: {
            type: String,
        },
        // 视频封面
        cover: {
            type: String
        },
        // 视频
        video: {
            // type: Object,
        },
        // 图片
        imgs: {
            type: Array,
            default: () => {
                [];
            }
        },
        height: {
            type: Number,
            default: 320
        }
    },
    data() {
        return {
            swiperIndex: 0,
            dotCount: 0,
            isPlay: false,
        };
    },
    watch: {
        imgs(){
            let dotCount = this.imgs.length;
            if (this.type == 'lifestyle' && this.video && this.video.video) {
                dotCount += 1;
            }
            if (this.type == 'house' && this.video) {
                dotCount += 1;
            }
            
            this.dotCount = dotCount;
        }
    },
    mounted(){
        
    },
    methods: {
        playVideo() {
            this.$refs.video.play();
            this.$refs.video.onpause = () => {
                this.isPlay = false;
            }
            this.isPlay = true;
        },
        swipeChange(index) {
            this.swiperIndex = index;
        }
    }
};
</script>

<style>
.w-swiper {
    position: relative;
    height: 320px;
    background-color: #f8f8f8;
}

.w-swiper .van-swipe {
    height: 100%;
}

.w-swiper .swiper-video,
.w-swiper .swiper-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.w-swiper .video-control{
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background-color: rgba(0,0,0,.6);
    display: flex;
    align-items: center;
    justify-content: center;
}
.w-swiper .video-control .iconfont{
    color: #fff;
    font-size: 40px;
}

.w-swiper .dots {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 25px;
    display: flex;
    margin: 0 auto;
    width: 45px;
    height: 3px;
    background: rgba(255, 255, 255, 0.4);
    border-radius: 1.5px;
}

.w-swiper .dot {
    flex: 1;
    height: 3px;
    border-radius: 1.5px;
    transition: all 0.3s;
}

.w-swiper .dot-active {
    background: rgba(255, 255, 255, 1);
}
</style>
